var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { RfpMessageListItem } from '@/components/modules/pages/rfp/client/List/RfpMessageListItem';
import { RfpMessageFormBox, RfpMessageFormBoxSkeleton, } from '@/components/modules/pages/rfp/client/Surface/RfpMessageFormBox';
import { ColorPaperButton } from '@/components/ui/Button/ColorPaperButton';
import { reDraw } from '@/helpers/common';
import { usePrevious } from '@/hooks/lifecycle/usePrevious';
import { useBoolState } from '@/hooks/state/useBoolState';
import { sleep } from '@/utils/async/sleep';
import { rfpNegotiateMessageValidation } from '@/utils/validate/resources/rfp/rfpNegotiateMessage';
// アコーディオン開閉時間
export const transitionTime = 250;
export const RfpMessageListRow = (props) => {
    var _a, _b, _c;
    const { budgetNegotiate, displayLastMessageBudget, displayLastMessageEndDate, displayLastMessageStartDate, endDateNegotiate, isCallEnd, isDifferentUserForRequestProfessional, item, loadingOfGetOne = false, onClickDraftBudget, onClickDraftEndDate, onClickDraftStartDate, onClickItem, onClickSubmitBudget, onClickSubmitEndDate, onClickSubmitStartDate, selectedId, startDateNegotiate, } = props;
    const divRef = useRef();
    const isChecked = item.id === selectedId;
    const { boolState, changeFalse, changeTrue } = useBoolState({
        initialState: item.id === selectedId,
    });
    const previewIsChecked = usePrevious(isChecked);
    // 表示状態の変遷の指定
    const viewMode = useMemo(() => {
        if (previewIsChecked === false && isChecked) {
            // false => trueになった場合
            return 'update_on';
        }
        if (previewIsChecked === true && !isChecked) {
            // true => falseになった場合
            return 'update_off';
        }
        if (previewIsChecked === undefined && isChecked) {
            // 初期表示の場合
            return 'default_on';
        }
        // 初期表示ではない場合
        return 'default_off';
    }, [previewIsChecked, isChecked]);
    // 要素の高さの指定
    const [height, changeHeight] = useState('0px');
    const heightRef = useRef();
    heightRef.current = height;
    const collapse = useCallback((startHeight, doingHeight, endHeight) => __awaiter(void 0, void 0, void 0, function* () {
        // 既に最終状態だったら何もしない
        if (heightRef.current === endHeight) {
            return;
        }
        // 初期設定
        changeHeight(startHeight);
        yield sleep(0);
        reDraw(divRef.current);
        yield sleep(0);
        // 初期設定から移動先の高さへ変更
        changeHeight(doingHeight);
        yield sleep(0);
        reDraw(divRef.current);
        yield sleep(transitionTime);
        // 最終設定の高さに
        changeHeight(endHeight);
        yield sleep(0);
        reDraw(divRef.current);
        yield sleep(0);
    }), [divRef, heightRef, changeHeight]);
    const collapseOn = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        const currentHeight = (_d = divRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().height;
        yield collapse(`0px`, `${currentHeight}px`, 'auto');
    }), [divRef, collapse]);
    const collapseOff = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        const currentHeight = (_e = divRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().height;
        yield collapse(`${currentHeight}px`, `0px`, `0px`);
    }), [divRef, collapse]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (viewMode === 'update_on') {
                // false => trueになった場合
                changeHeight('0px');
                changeTrue();
                yield sleep(0);
                yield collapseOn();
            }
            if (viewMode === 'update_off') {
                // true => falseになった場合
                yield collapseOff();
                changeFalse();
            }
        }))();
    }, [viewMode, divRef, changeTrue, changeFalse, collapseOn, collapseOff]);
    const setCss = css `
    height: ${height};
  `;
    const onClickListItem = useCallback((id) => {
        onClickItem(id);
        collapseOn();
    }, [onClickItem, collapseOn]);
    return (_jsxs(_Fragment, { children: [_jsx(RfpMessageListItem, { className: 'block md:hidden lg:block xl:hidden', companyName: item.companyName, disabled: loadingOfGetOne, hasUnAnswer: !isCallEnd && item.hasUnAnswer, id: item.id, isSelected: item.id === selectedId, onClick: onClickListItem, unReadCount: item.unReadCount }), boolState && (_jsx("div", Object.assign({ className: clsx('transition-[height] md:transition-none duration-[250ms]', 'overflow-y-hidden h-0 md:!h-auto'), css: height ? setCss : undefined }, { children: _jsxs("div", Object.assign({ ref: (element) => {
                        if (element) {
                            divRef.current = element;
                        }
                    } }, { children: [_jsxs("div", Object.assign({ className: clsx('flex flex-col gap-y-16') }, { children: [loadingOfGetOne && (_jsxs(_Fragment, { children: [_jsx(RfpMessageFormBoxSkeleton, {}), _jsx(RfpMessageFormBoxSkeleton, {}), _jsx(RfpMessageFormBoxSkeleton, {})] })), !loadingOfGetOne &&
                                    budgetNegotiate &&
                                    !!((_a = budgetNegotiate === null || budgetNegotiate === void 0 ? void 0 : budgetNegotiate.chatItems) === null || _a === void 0 ? void 0 : _a.length) && (_jsx(RfpMessageFormBox, { chatItems: budgetNegotiate.chatItems, displayLastMessage: displayLastMessageBudget, draftMessage: budgetNegotiate.draftMessage, hasUnRead: budgetNegotiate.hasUnRead, isDifferentUserForRequestProfessional: isDifferentUserForRequestProfessional, isShowForm: !isCallEnd, onClickDraft: onClickDraftBudget, onClickSubmit: onClickSubmitBudget, status: budgetNegotiate.status, title: '予算について', user: budgetNegotiate.user, validateOfMessage: rfpNegotiateMessageValidation.description, viewRequestId: selectedId }, '予算について')), !loadingOfGetOne &&
                                    startDateNegotiate &&
                                    !!((_b = startDateNegotiate === null || startDateNegotiate === void 0 ? void 0 : startDateNegotiate.chatItems) === null || _b === void 0 ? void 0 : _b.length) && (_jsx(RfpMessageFormBox, { chatItems: startDateNegotiate.chatItems, displayLastMessage: displayLastMessageStartDate, draftMessage: startDateNegotiate.draftMessage, hasUnRead: startDateNegotiate.hasUnRead, isDifferentUserForRequestProfessional: isDifferentUserForRequestProfessional, isShowForm: !isCallEnd, onClickDraft: onClickDraftStartDate, onClickSubmit: onClickSubmitStartDate, status: startDateNegotiate.status, title: 'プロジェクト開始時期について', user: startDateNegotiate.user, validateOfMessage: rfpNegotiateMessageValidation.description, viewRequestId: selectedId }, 'プロジェクト開始時期について')), !loadingOfGetOne &&
                                    endDateNegotiate &&
                                    !!((_c = endDateNegotiate === null || endDateNegotiate === void 0 ? void 0 : endDateNegotiate.chatItems) === null || _c === void 0 ? void 0 : _c.length) && (_jsx(RfpMessageFormBox, { chatItems: endDateNegotiate.chatItems, displayLastMessage: displayLastMessageEndDate, draftMessage: endDateNegotiate.draftMessage, hasUnRead: endDateNegotiate.hasUnRead, isDifferentUserForRequestProfessional: isDifferentUserForRequestProfessional, isShowForm: !isCallEnd, onClickDraft: onClickDraftEndDate, onClickSubmit: onClickSubmitEndDate, status: endDateNegotiate.status, title: 'プロジェクト終了時期について', user: endDateNegotiate.user, validateOfMessage: rfpNegotiateMessageValidation.description, viewRequestId: selectedId }, 'プロジェクト終了時期について'))] })), _jsx(ColorPaperButton, Object.assign({ className: 'block md:hidden lg:block xl:hidden', onClick: collapseOff }, { children: "\u9589\u3058\u308B" }))] })) })))] }));
};
